/* CLEO — Página 4 · Empezar — cleo-empezar.js
   = script.js del ZIP. 3 calculadoras STAR/PRO/MENTORA INTACTAS.
   setupForm roto reemplazado + buscador ciudad CLEO + smooth scroll. */
/* ============================================================
   CLEO — Página 2 "Quiero empezar"
   STAR + PRO + MENTORA calculadoras · FAQ · Formulario
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     HERO TITLE — stagger letter-by-letter (preserving words)
     ---------------------------------------------------------- */
  function splitHeroTitle() {
    var title = document.querySelector('.cleo-empezar-hero__title');
    if (!title) return;
    var raw = title.textContent.trim();
    title.textContent = '';
    var words = raw.split(/\s+/);
    var letterIdx = 0;
    words.forEach(function (word, wi) {
      var wSpan = document.createElement('span');
      wSpan.className = 'word';
      wSpan.style.whiteSpace = 'nowrap';
      wSpan.style.display = 'inline-block';
      for (var i = 0; i < word.length; i++) {
        var ch = document.createElement('span');
        ch.className = 'cleo-letter';
        ch.style.setProperty('--i', letterIdx++);
        ch.textContent = word[i];
        wSpan.appendChild(ch);
      }
      title.appendChild(wSpan);
      if (wi < words.length - 1) {
        title.appendChild(document.createTextNode(' '));
      }
    });
  }

  /* ----------------------------------------------------------
     REVEAL on scroll + immediate for in-view at load
     ---------------------------------------------------------- */
  function setupReveal() {
    var nodes = document.querySelectorAll('.reveal');
    if (!nodes.length) return;

    // Immediate visible elements
    nodes.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('is-visible');
      }
    });

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ----------------------------------------------------------
     HELPERS — number format
     ---------------------------------------------------------- */
  function fmtGs(n) {
    if (isNaN(n)) n = 0;
    return new Intl.NumberFormat('es-PY').format(Math.round(n));
  }
  function parseNum(str) {
    if (typeof str !== 'string') str = String(str || '');
    var n = parseInt(str.replace(/[^\d]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }
  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function flip(el) {
    if (!el) return;
    el.classList.remove('is-flip');
    void el.offsetWidth;
    el.classList.add('is-flip');
  }

  /* ----------------------------------------------------------
     STAR CALCULATOR — 33% markup, no bono
     ---------------------------------------------------------- */
  var STAR_MIN = 100000, STAR_MAX = 50000000, STAR_STEP = 100000;
  function calcStar(compras) {
    var vendes = Math.round(compras * 1.33);
    var ganancia = vendes - compras;
    return { vendes: vendes, ganancia: ganancia };
  }
  function renderStar(compras) {
    var r = calcStar(compras);
    var hl = document.getElementById('cleo-star-headline');
    var ov = document.getElementById('cleo-star-out-vendes');
    var ot = document.getElementById('cleo-star-out-total');
    if (hl) hl.textContent = 'Gs ' + fmtGs(compras);
    if (ot) { ot.textContent = 'Gs ' + fmtGs(r.ganancia); flip(ot); }
  }
  function setupStar() {
    var input = document.getElementById('cleo-star-input');
    if (!input) return;
    function commit() {
      var n = clamp(parseNum(input.value), STAR_MIN, STAR_MAX);
      input.value = fmtGs(n);
      renderStar(n);
    }
    input.addEventListener('input', function () {
      var n = parseNum(input.value);
      if (n > STAR_MAX) n = STAR_MAX;
      input.value = fmtGs(n);
      renderStar(n);
    });
    input.addEventListener('blur', commit);
    document.querySelectorAll('.cleo-calc__step[data-target="star"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cur = parseNum(input.value);
        var dir = btn.getAttribute('data-step') === 'up' ? 1 : -1;
        var next = clamp(cur + dir * STAR_STEP, STAR_MIN, STAR_MAX);
        input.value = fmtGs(next);
        renderStar(next);
      });
    });
    renderStar(parseNum(input.value));
  }

  function fillStarTable() {
    var rows = [200000, 500000, 1000000, 2000000, 3000000, 5000000, 7000000, 10000000];
    var tbody = document.getElementById('cleo-star-tabla-body');
    var cards = document.getElementById('cleo-star-cards');
    if (tbody) {
      tbody.innerHTML = rows.map(function (c) {
        var r = calcStar(c);
        return '<tr>' +
          '<td><strong>Gs ' + fmtGs(c) + '</strong></td>' +
          '<td class="t-ganas"><strong>Gs ' + fmtGs(r.ganancia) + '</strong></td>' +
          '</tr>';
      }).join('');
    }
    if (cards) {
      cards.innerHTML = rows.map(function (c) {
        var r = calcStar(c);
        return '<div class="cleo-calc__minicard">' +
          '<div class="cleo-calc__minicard-head">Gs ' + fmtGs(c) + '/mes</div>' +
          '<div class="cleo-calc__minicard-row"><span>Vendés</span><strong>Gs ' + fmtGs(r.vendes) + '</strong></div>' +
          '<div class="cleo-calc__minicard-row r-total"><span>🥰 Ganás</span><strong>Gs ' + fmtGs(r.ganancia) + '</strong></div>' +
          '</div>';
      }).join('');
    }
  }

  /* ----------------------------------------------------------
     PRO CALCULATOR — 43% markup + 10% bono
     ---------------------------------------------------------- */
  var PRO_MIN = 100000, PRO_MAX = 50000000, PRO_STEP = 100000;
  function calcPro(compras) {
    var vendes = Math.round(compras * 1.43);
    var ganancia = vendes - compras;
    var bono = Math.round(compras * 0.10);
    var total = ganancia + bono;
    return { vendes: vendes, ganancia: ganancia, bono: bono, total: total };
  }
  function renderPro(compras) {
    var r = calcPro(compras);
    var hl = document.getElementById('cleo-calc-headline');
    var ov = document.getElementById('cleo-out-vendes');
    var og = document.getElementById('cleo-out-ganancia');
    var ob = document.getElementById('cleo-out-bono');
    var ot = document.getElementById('cleo-out-total');
    if (hl) hl.textContent = 'Gs ' + fmtGs(compras);
    if (og) { og.textContent = '+Gs ' + fmtGs(r.ganancia); flip(og); }
    if (ob) { ob.textContent = '+Gs ' + fmtGs(r.bono); flip(ob); }
    if (ot) { ot.textContent = 'Gs ' + fmtGs(r.total); flip(ot); }
  }
  function setupPro() {
    var input = document.getElementById('cleo-calc-input');
    if (!input) return;
    function commit() {
      var n = clamp(parseNum(input.value), PRO_MIN, PRO_MAX);
      input.value = fmtGs(n);
      renderPro(n);
    }
    input.addEventListener('input', function () {
      var n = parseNum(input.value);
      if (n > PRO_MAX) n = PRO_MAX;
      input.value = fmtGs(n);
      renderPro(n);
    });
    input.addEventListener('blur', commit);
    document.querySelectorAll('.cleo-calc__step[data-target="pro"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cur = parseNum(input.value);
        var dir = btn.getAttribute('data-step') === 'up' ? 1 : -1;
        var next = clamp(cur + dir * PRO_STEP, PRO_MIN, PRO_MAX);
        input.value = fmtGs(next);
        renderPro(next);
      });
    });
    renderPro(parseNum(input.value));
  }

  function fillProTable() {
    var rows = [500000, 1000000, 2000000, 3000000, 5000000, 7000000, 10000000];
    var tbody = document.getElementById('cleo-calc-tabla-body');
    var cards = document.getElementById('cleo-calc-cards');
    if (tbody) {
      tbody.innerHTML = rows.map(function (c) {
        var r = calcPro(c);
        return '<tr>' +
          '<td><strong>Gs ' + fmtGs(c) + '</strong></td>' +
          '<td class="t-ganas">Gs ' + fmtGs(r.ganancia) + '</td>' +
          '<td class="t-bono">+Gs ' + fmtGs(r.bono) + '</td>' +
          '<td class="t-total"><strong>Gs ' + fmtGs(r.total) + '</strong></td>' +
          '</tr>';
      }).join('');
    }
    if (cards) {
      cards.innerHTML = rows.map(function (c) {
        var r = calcPro(c);
        return '<div class="cleo-calc__minicard">' +
          '<div class="cleo-calc__minicard-head">Gs ' + fmtGs(c) + '/mes</div>' +
          '<div class="cleo-calc__minicard-row"><span>Vendés</span><strong>Gs ' + fmtGs(r.vendes) + '</strong></div>' +
          '<div class="cleo-calc__minicard-row"><span>Ganás</span><strong>Gs ' + fmtGs(r.ganancia) + '</strong></div>' +
          '<div class="cleo-calc__minicard-row r-bono"><span>🎁 Bono</span><strong>+Gs ' + fmtGs(r.bono) + '</strong></div>' +
          '<div class="cleo-calc__minicard-row r-total"><span>🥰 Total</span><strong>Gs ' + fmtGs(r.total) + '</strong></div>' +
          '</div>';
      }).join('');
    }
  }

  /* ----------------------------------------------------------
     MENTORA CALCULATOR
     Inputs: # emprendedoras, compra por emprendedora, mis compras propias
     ---------------------------------------------------------- */
  var MTR = {
    ne:  { min: 1, max: 500, step: 1,        id: 'cleo-mtr-ne',  parse: parseNum, format: function (n) { return String(n); } },
    cpe: { min: 100000, max: 10000000, step: 100000, id: 'cleo-mtr-cpe', parse: parseNum, format: fmtGs },
    cp:  { min: 100000, max: 50000000, step: 100000, id: 'cleo-mtr-cp',  parse: parseNum, format: fmtGs }
  };

  function calcMentora(ne, cpe, cp) {
    var bonoEquipo = Math.round((ne * cpe) * 0.08);
    var vendes = Math.round(cp * 1.43);
    var gananciaPropia = vendes - cp;
    var bonoMensual = Math.round(cp * 0.10);
    var total = bonoEquipo + gananciaPropia + bonoMensual;
    return {
      bonoEquipo: bonoEquipo,
      gananciaPropia: gananciaPropia,
      bonoMensual: bonoMensual,
      total: total
    };
  }
  function renderMentora() {
    var ne  = clamp(MTR.ne.parse(document.getElementById(MTR.ne.id).value),  MTR.ne.min,  MTR.ne.max);
    var cpe = clamp(MTR.cpe.parse(document.getElementById(MTR.cpe.id).value), MTR.cpe.min, MTR.cpe.max);
    var cp  = clamp(MTR.cp.parse(document.getElementById(MTR.cp.id).value),   MTR.cp.min,  MTR.cp.max);
    var r = calcMentora(ne, cpe, cp);
    var be = document.getElementById('cleo-mtr-out-bono-equipo');
    var gp = document.getElementById('cleo-mtr-out-ganancia');
    var bm = document.getElementById('cleo-mtr-out-bono-mensual');
    var tt = document.getElementById('cleo-mtr-out-total');
    if (be) { be.textContent = '+Gs ' + fmtGs(r.bonoEquipo);    flip(be); }
    if (gp) { gp.textContent = '+Gs ' + fmtGs(r.gananciaPropia); flip(gp); }
    if (bm) { bm.textContent = '+Gs ' + fmtGs(r.bonoMensual);    flip(bm); }
    if (tt) { tt.textContent = 'Gs '  + fmtGs(r.total);          flip(tt); }
  }
  function bindMentoraInput(key) {
    var conf = MTR[key];
    var input = document.getElementById(conf.id);
    if (!input) return;
    function commit() {
      var n = clamp(conf.parse(input.value), conf.min, conf.max);
      input.value = conf.format(n);
      renderMentora();
    }
    input.addEventListener('input', function () {
      var n = conf.parse(input.value);
      if (n > conf.max) n = conf.max;
      input.value = conf.format(n);
      renderMentora();
    });
    input.addEventListener('blur', commit);
    document.querySelectorAll('.cleo-mtr-step[data-mtr="' + key + '"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cur = conf.parse(input.value);
        var dir = btn.getAttribute('data-step') === 'up' ? 1 : -1;
        var next = clamp(cur + dir * conf.step, conf.min, conf.max);
        input.value = conf.format(next);
        renderMentora();
      });
    });
  }
  function setupMentora() {
    if (!document.getElementById(MTR.ne.id)) return;
    bindMentoraInput('ne');
    bindMentoraInput('cpe');
    bindMentoraInput('cp');
    renderMentora();
  }

  function fillMentoraTable() {
    var rows = [
      { cpe: 400000,  cp:  8000000 },
      { cpe: 700000,  cp:  9000000 },
      { cpe: 1000000, cp: 12000000 }
    ];
    var tbody = document.getElementById('cleo-mtr-tabla-body');
    var cards = document.getElementById('cleo-mtr-cards');
    if (tbody) {
      tbody.innerHTML = rows.map(function (row) {
        var r = calcMentora(30, row.cpe, row.cp);
        return '<tr>' +
          '<td><strong>Gs ' + fmtGs(row.cpe) + '</strong></td>' +
          '<td>Gs ' + fmtGs(row.cp) + '</td>' +
          '<td class="t-bono">+Gs ' + fmtGs(r.bonoEquipo) + '</td>' +
          '<td class="t-ganas">+Gs ' + fmtGs(r.gananciaPropia) + '</td>' +
          '<td class="t-bono">+Gs ' + fmtGs(r.bonoMensual) + '</td>' +
          '<td class="t-total"><strong>Gs ' + fmtGs(r.total) + '</strong></td>' +
          '</tr>';
      }).join('');
    }
    if (cards) {
      cards.innerHTML = rows.map(function (row) {
        var r = calcMentora(30, row.cpe, row.cp);
        return '<div class="cleo-calc__minicard">' +
          '<div class="cleo-calc__minicard-head">Cada una: Gs ' + fmtGs(row.cpe) + ' · Vos: Gs ' + fmtGs(row.cp) + '</div>' +
          '<div class="cleo-calc__minicard-row r-bono"><span>🤝 Bono equipo</span><strong>+Gs ' + fmtGs(r.bonoEquipo) + '</strong></div>' +
          '<div class="cleo-calc__minicard-row"><span>💜 Tu ganancia</span><strong>+Gs ' + fmtGs(r.gananciaPropia) + '</strong></div>' +
          '<div class="cleo-calc__minicard-row r-bono"><span>🎁 Tu bono</span><strong>+Gs ' + fmtGs(r.bonoMensual) + '</strong></div>' +
          '<div class="cleo-calc__minicard-row r-total"><span>🥰 Total</span><strong>Gs ' + fmtGs(r.total) + '</strong></div>' +
          '</div>';
      }).join('');
    }
  }

  /* ----------------------------------------------------------
     FAQ — only one open at a time (mobile-friendly)
     ---------------------------------------------------------- */
  function setupFaq() {
    var items = document.querySelectorAll('.cleo-faq__item');
    items.forEach(function (it) {
      it.addEventListener('toggle', function () {
        if (it.open && window.matchMedia('(max-width: 720px)').matches) {
          items.forEach(function (other) {
            if (other !== it) other.open = false;
          });
        }
      });
    });
  }

  /* ----------------------------------------------------------
     FORM — submit handler (REEMPLAZADO Cowork Sprint 4)
     El setupForm del ZIP apuntaba a IDs inexistentes. Reemplazado
     por el manejador probado de Sprint 1/3, apuntando a los IDs
     REALES del HTML. Las 3 calculadoras quedan 100% intactas.
     ---------------------------------------------------------- */
  function setupForm() {
    var form = document.getElementById('cleo-form-preregistro-empezar');
    var success = document.getElementById('cleo-form-success');
    var btn = document.getElementById('bl-pg-btn');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      // honeypot real: name="website"
      var hp = form.querySelector('input[name="website"]');
      if (hp && hp.value) return;
      // ciudad obligatoria (buscador custom)
      var cityVal = document.getElementById('bl-pg-city-val');
      var cityInput = document.getElementById('bl-pg-city-input');
      if (cityVal && !cityVal.value) {
        if (cityInput) { cityInput.style.borderColor = '#e0457a'; cityInput.focus(); }
        alert('Por favor elegí tu ciudad de la lista.');
        return;
      }
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Enviando…'; }
      var data = new FormData(form);
      fetch(form.action, { method: 'POST', body: data, mode: 'no-cors' })
        .then(function () { form.style.display = 'none'; if (success) success.classList.add('is-visible'); })
        .catch(function () { form.style.display = 'none'; if (success) success.classList.add('is-visible'); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = originalText; } });
    });

    // WhatsApp — formato suave
    var wa = document.getElementById('bl-pg-wa');
    if (wa) {
      wa.addEventListener('input', function () {
        var v = wa.value.replace(/[^\d]/g, '').slice(0, 10);
        if (v.length > 4) v = v.slice(0, 4) + ' ' + v.slice(4);
        if (v.length > 8) v = v.slice(0, 8) + ' ' + v.slice(8);
        wa.value = v;
      });
    }
  }

  /* ----------------------------------------------------------
     BUSCADOR DE CIUDAD CLEO (reemplaza datalist nativo) — Sprint 1
     ---------------------------------------------------------- */
  function setupCityDropdown() {
    var wrap = document.getElementById('cleo-city-wrap');
    var input = document.getElementById('bl-pg-city-input');
    var arrow = wrap ? wrap.querySelector('.cleo-city-arrow') : null;
    var dd = document.getElementById('cleo-city-dd');
    var search = document.getElementById('cleo-city-search');
    var list = document.getElementById('cleo-city-list');
    var hidden = document.getElementById('bl-pg-city-val');
    if (!wrap || !input || !dd || !list || !hidden) return;
    function openDD() {
      dd.classList.add('is-open'); wrap.classList.add('is-open');
      search.value = ''; filterList('');
      setTimeout(function () { search.focus(); }, 40);
    }
    function closeDD() { dd.classList.remove('is-open'); wrap.classList.remove('is-open'); }
    function filterList(q) {
      var qq = q.toLowerCase().trim(), anyVisible = false;
      list.querySelectorAll('li:not(.is-empty)').forEach(function (li) {
        var match = li.textContent.toLowerCase().indexOf(qq) >= 0;
        li.hidden = !match; if (match) anyVisible = true;
      });
      var empty = list.querySelector('.is-empty');
      if (!anyVisible) {
        if (!empty) {
          empty = document.createElement('li'); empty.className = 'is-empty';
          empty.textContent = 'Sin resultados — escribí tu ciudad';
          list.appendChild(empty);
        }
        empty.hidden = false;
      } else if (empty) { empty.hidden = true; }
    }
    input.addEventListener('click', function () { dd.classList.contains('is-open') ? closeDD() : openDD(); });
    if (arrow) arrow.addEventListener('click', function () { dd.classList.contains('is-open') ? closeDD() : openDD(); });
    search.addEventListener('input', function () { filterList(this.value); });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('li');
      if (!li || li.classList.contains('is-empty')) return;
      input.value = li.dataset.val; hidden.value = li.dataset.val;
      input.style.color = 'var(--cleo-negro)'; closeDD();
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) closeDD(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dd.classList.contains('is-open')) closeDD(); });
  }

  /* ----------------------------------------------------------
     SMOOTH SCROLL — anchors internos (#nivel-star/pro/mentora)
     ---------------------------------------------------------- */
  function setupSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var t = document.querySelector(id);
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  /* ----------------------------------------------------------
     INIT
     ---------------------------------------------------------- */
  function init() {
    splitHeroTitle();
    setupReveal();
    setupStar();
    setupPro();
    setupMentora();
    fillStarTable();
    fillProTable();
    fillMentoraTable();
    setupFaq();
    setupForm();
    setupCityDropdown();
    setupSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ============================================================
   CLEO — Página 2 "Quiero empezar"
   STAR + PRO + MENTORA calculadoras · FAQ · Formulario
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     HERO TITLE — stagger letter-by-letter (preserving words)
     ---------------------------------------------------------- */
  function splitHeroTitle() {
    var title = document.querySelector('.cleo-empezar-hero__title');
    if (!title) return;
    var raw = title.textContent.trim();
    title.textContent = '';
    var words = raw.split(/\s+/);
    var letterIdx = 0;
    words.forEach(function (word, wi) {
      var wSpan = document.createElement('span');
      wSpan.className = 'word';
      wSpan.style.whiteSpace = 'nowrap';
      wSpan.style.display = 'inline-block';
      for (var i = 0; i < word.length; i++) {
        var ch = document.createElement('span');
        ch.className = 'cleo-letter';
        ch.style.setProperty('--i', letterIdx++);
        ch.textContent = word[i];
        wSpan.appendChild(ch);
      }
      title.appendChild(wSpan);
      if (wi < words.length - 1) {
        title.appendChild(document.createTextNode(' '));
      }
    });
  }

  /* ----------------------------------------------------------
     REVEAL on scroll + immediate for in-view at load
     ---------------------------------------------------------- */
  function setupReveal() {
    var nodes = document.querySelectorAll('.reveal');
    if (!nodes.length) return;

    // Immediate visible elements
    nodes.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('is-visible');
      }
    });

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ----------------------------------------------------------
     HELPERS — number format
     ---------------------------------------------------------- */
  function fmtGs(n) {
    if (isNaN(n)) n = 0;
    return new Intl.NumberFormat('es-PY').format(Math.round(n));
  }
  function parseNum(str) {
    if (typeof str !== 'string') str = String(str || '');
    var n = parseInt(str.replace(/[^\d]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }
  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function flip(el) {
    if (!el) return;
    el.classList.remove('is-flip');
    void el.offsetWidth;
    el.classList.add('is-flip');
  }

  /* ----------------------------------------------------------
     STAR CALCULATOR — 33% markup, no bono
     ---------------------------------------------------------- */
  var STAR_MIN = 100000, STAR_MAX = 50000000, STAR_STEP = 100000;
  function calcStar(compras) {
    var vendes = Math.round(compras * 1.33);
    var ganancia = vendes - compras;
    return { vendes: vendes, ganancia: ganancia };
  }
  function renderStar(compras) {
    var r = calcStar(compras);
    var hl = document.getElementById('cleo-star-headline');
    var ov = document.getElementById('cleo-star-out-vendes');
    var ot = document.getElementById('cleo-star-out-total');
    if (hl) hl.textContent = 'Gs ' + fmtGs(compras);
    if (ot) { ot.textContent = 'Gs ' + fmtGs(r.ganancia); flip(ot); }
  }
  function setupStar() {
    var input = document.getElementById('cleo-star-input');
    if (!input) return;
    function commit() {
      var n = clamp(parseNum(input.value), STAR_MIN, STAR_MAX);
      input.value = fmtGs(n);
      renderStar(n);
    }
    input.addEventListener('input', function () {
      var n = parseNum(input.value);
      if (n > STAR_MAX) n = STAR_MAX;
      input.value = fmtGs(n);
      renderStar(n);
    });
    input.addEventListener('blur', commit);
    document.querySelectorAll('.cleo-calc__step[data-target="star"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cur = parseNum(input.value);
        var dir = btn.getAttribute('data-step') === 'up' ? 1 : -1;
        var next = clamp(cur + dir * STAR_STEP, STAR_MIN, STAR_MAX);
        input.value = fmtGs(next);
        renderStar(next);
      });
    });
    renderStar(parseNum(input.value));
  }

  function fillStarTable() {
    var rows = [200000, 500000, 1000000, 2000000, 3000000, 5000000, 7000000, 10000000];
    var tbody = document.getElementById('cleo-star-tabla-body');
    var cards = document.getElementById('cleo-star-cards');
    if (tbody) {
      tbody.innerHTML = rows.map(function (c) {
        var r = calcStar(c);
        return '<tr>' +
          '<td><strong>Gs ' + fmtGs(c) + '</strong></td>' +
          '<td class="t-ganas"><strong>Gs ' + fmtGs(r.ganancia) + '</strong></td>' +
          '</tr>';
      }).join('');
    }
    if (cards) {
      cards.innerHTML = rows.map(function (c) {
        var r = calcStar(c);
        return '<div class="cleo-calc__minicard">' +
          '<div class="cleo-calc__minicard-head">Gs ' + fmtGs(c) + '/mes</div>' +
          '<div class="cleo-calc__minicard-row"><span>Vendés</span><strong>Gs ' + fmtGs(r.vendes) + '</strong></div>' +
          '<div class="cleo-calc__minicard-row r-total"><span>🥰 Ganás</span><strong>Gs ' + fmtGs(r.ganancia) + '</strong></div>' +
          '</div>';
      }).join('');
    }
  }

  /* ----------------------------------------------------------
     PRO CALCULATOR — 43% markup + 10% bono
     ---------------------------------------------------------- */
  var PRO_MIN = 100000, PRO_MAX = 50000000, PRO_STEP = 100000;
  function calcPro(compras) {
    var vendes = Math.round(compras * 1.43);
    var ganancia = vendes - compras;
    var bono = Math.round(compras * 0.10);
    var total = ganancia + bono;
    return { vendes: vendes, ganancia: ganancia, bono: bono, total: total };
  }
  function renderPro(compras) {
    var r = calcPro(compras);
    var hl = document.getElementById('cleo-calc-headline');
    var ov = document.getElementById('cleo-out-vendes');
    var og = document.getElementById('cleo-out-ganancia');
    var ob = document.getElementById('cleo-out-bono');
    var ot = document.getElementById('cleo-out-total');
    if (hl) hl.textContent = 'Gs ' + fmtGs(compras);
    if (og) { og.textContent = '+Gs ' + fmtGs(r.ganancia); flip(og); }
    if (ob) { ob.textContent = '+Gs ' + fmtGs(r.bono); flip(ob); }
    if (ot) { ot.textContent = 'Gs ' + fmtGs(r.total); flip(ot); }
  }
  function setupPro() {
    var input = document.getElementById('cleo-calc-input');
    if (!input) return;
    function commit() {
      var n = clamp(parseNum(input.value), PRO_MIN, PRO_MAX);
      input.value = fmtGs(n);
      renderPro(n);
    }
    input.addEventListener('input', function () {
      var n = parseNum(input.value);
      if (n > PRO_MAX) n = PRO_MAX;
      input.value = fmtGs(n);
      renderPro(n);
    });
    input.addEventListener('blur', commit);
    document.querySelectorAll('.cleo-calc__step[data-target="pro"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cur = parseNum(input.value);
        var dir = btn.getAttribute('data-step') === 'up' ? 1 : -1;
        var next = clamp(cur + dir * PRO_STEP, PRO_MIN, PRO_MAX);
        input.value = fmtGs(next);
        renderPro(next);
      });
    });
    renderPro(parseNum(input.value));
  }

  function fillProTable() {
    var rows = [500000, 1000000, 2000000, 3000000, 5000000, 7000000, 10000000];
    var tbody = document.getElementById('cleo-calc-tabla-body');
    var cards = document.getElementById('cleo-calc-cards');
    if (tbody) {
      tbody.innerHTML = rows.map(function (c) {
        var r = calcPro(c);
        return '<tr>' +
          '<td><strong>Gs ' + fmtGs(c) + '</strong></td>' +
          '<td class="t-ganas">Gs ' + fmtGs(r.ganancia) + '</td>' +
          '<td class="t-bono">+Gs ' + fmtGs(r.bono) + '</td>' +
          '<td class="t-total"><strong>Gs ' + fmtGs(r.total) + '</strong></td>' +
          '</tr>';
      }).join('');
    }
    if (cards) {
      cards.innerHTML = rows.map(function (c) {
        var r = calcPro(c);
        return '<div class="cleo-calc__minicard">' +
          '<div class="cleo-calc__minicard-head">Gs ' + fmtGs(c) + '/mes</div>' +
          '<div class="cleo-calc__minicard-row"><span>Vendés</span><strong>Gs ' + fmtGs(r.vendes) + '</strong></div>' +
          '<div class="cleo-calc__minicard-row"><span>Ganás</span><strong>Gs ' + fmtGs(r.ganancia) + '</strong></div>' +
          '<div class="cleo-calc__minicard-row r-bono"><span>🎁 Bono</span><strong>+Gs ' + fmtGs(r.bono) + '</strong></div>' +
          '<div class="cleo-calc__minicard-row r-total"><span>🥰 Total</span><strong>Gs ' + fmtGs(r.total) + '</strong></div>' +
          '</div>';
      }).join('');
    }
  }

  /* ----------------------------------------------------------
     MENTORA CALCULATOR
     Inputs: # emprendedoras, compra por emprendedora, mis compras propias
     ---------------------------------------------------------- */
  var MTR = {
    ne:  { min: 1, max: 500, step: 1,        id: 'cleo-mtr-ne',  parse: parseNum, format: function (n) { return String(n); } },
    cpe: { min: 100000, max: 10000000, step: 100000, id: 'cleo-mtr-cpe', parse: parseNum, format: fmtGs },
    cp:  { min: 100000, max: 50000000, step: 100000, id: 'cleo-mtr-cp',  parse: parseNum, format: fmtGs }
  };

  function calcMentora(ne, cpe, cp) {
    var bonoEquipo = Math.round((ne * cpe) * 0.08);
    var vendes = Math.round(cp * 1.43);
    var gananciaPropia = vendes - cp;
    var bonoMensual = Math.round(cp * 0.10);
    var total = bonoEquipo + gananciaPropia + bonoMensual;
    return {
      bonoEquipo: bonoEquipo,
      gananciaPropia: gananciaPropia,
      bonoMensual: bonoMensual,
      total: total
    };
  }
  function renderMentora() {
    var ne  = clamp(MTR.ne.parse(document.getElementById(MTR.ne.id).value),  MTR.ne.min,  MTR.ne.max);
    var cpe = clamp(MTR.cpe.parse(document.getElementById(MTR.cpe.id).value), MTR.cpe.min, MTR.cpe.max);
    var cp  = clamp(MTR.cp.parse(document.getElementById(MTR.cp.id).value),   MTR.cp.min,  MTR.cp.max);
    var r = calcMentora(ne, cpe, cp);
    var be = document.getElementById('cleo-mtr-out-bono-equipo');
    var gp = document.getElementById('cleo-mtr-out-ganancia');
    var bm = document.getElementById('cleo-mtr-out-bono-mensual');
    var tt = document.getElementById('cleo-mtr-out-total');
    if (be) { be.textContent = '+Gs ' + fmtGs(r.bonoEquipo);    flip(be); }
    if (gp) { gp.textContent = '+Gs ' + fmtGs(r.gananciaPropia); flip(gp); }
    if (bm) { bm.textContent = '+Gs ' + fmtGs(r.bonoMensual);    flip(bm); }
    if (tt) { tt.textContent = 'Gs '  + fmtGs(r.total);          flip(tt); }
  }
  function bindMentoraInput(key) {
    var conf = MTR[key];
    var input = document.getElementById(conf.id);
    if (!input) return;
    function commit() {
      var n = clamp(conf.parse(input.value), conf.min, conf.max);
      input.value = conf.format(n);
      renderMentora();
    }
    input.addEventListener('input', function () {
      var n = conf.parse(input.value);
      if (n > conf.max) n = conf.max;
      input.value = conf.format(n);
      renderMentora();
    });
    input.addEventListener('blur', commit);
    document.querySelectorAll('.cleo-mtr-step[data-mtr="' + key + '"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cur = conf.parse(input.value);
        var dir = btn.getAttribute('data-step') === 'up' ? 1 : -1;
        var next = clamp(cur + dir * conf.step, conf.min, conf.max);
        input.value = conf.format(next);
        renderMentora();
      });
    });
  }
  function setupMentora() {
    if (!document.getElementById(MTR.ne.id)) return;
    bindMentoraInput('ne');
    bindMentoraInput('cpe');
    bindMentoraInput('cp');
    renderMentora();
  }

  function fillMentoraTable() {
    var rows = [
      { cpe: 400000,  cp:  8000000 },
      { cpe: 700000,  cp:  9000000 },
      { cpe: 1000000, cp: 12000000 }
    ];
    var tbody = document.getElementById('cleo-mtr-tabla-body');
    var cards = document.getElementById('cleo-mtr-cards');
    if (tbody) {
      tbody.innerHTML = rows.map(function (row) {
        var r = calcMentora(30, row.cpe, row.cp);
        return '<tr>' +
          '<td><strong>Gs ' + fmtGs(row.cpe) + '</strong></td>' +
          '<td>Gs ' + fmtGs(row.cp) + '</td>' +
          '<td class="t-bono">+Gs ' + fmtGs(r.bonoEquipo) + '</td>' +
          '<td class="t-ganas">+Gs ' + fmtGs(r.gananciaPropia) + '</td>' +
          '<td class="t-bono">+Gs ' + fmtGs(r.bonoMensual) + '</td>' +
          '<td class="t-total"><strong>Gs ' + fmtGs(r.total) + '</strong></td>' +
          '</tr>';
      }).join('');
    }
    if (cards) {
      cards.innerHTML = rows.map(function (row) {
        var r = calcMentora(30, row.cpe, row.cp);
        return '<div class="cleo-calc__minicard">' +
          '<div class="cleo-calc__minicard-head">Cada una: Gs ' + fmtGs(row.cpe) + ' · Vos: Gs ' + fmtGs(row.cp) + '</div>' +
          '<div class="cleo-calc__minicard-row r-bono"><span>🤝 Bono equipo</span><strong>+Gs ' + fmtGs(r.bonoEquipo) + '</strong></div>' +
          '<div class="cleo-calc__minicard-row"><span>💜 Tu ganancia</span><strong>+Gs ' + fmtGs(r.gananciaPropia) + '</strong></div>' +
          '<div class="cleo-calc__minicard-row r-bono"><span>🎁 Tu bono</span><strong>+Gs ' + fmtGs(r.bonoMensual) + '</strong></div>' +
          '<div class="cleo-calc__minicard-row r-total"><span>🥰 Total</span><strong>Gs ' + fmtGs(r.total) + '</strong></div>' +
          '</div>';
      }).join('');
    }
  }

  /* ----------------------------------------------------------
     FAQ — only one open at a time (mobile-friendly)
     ---------------------------------------------------------- */
  function setupFaq() {
    var items = document.querySelectorAll('.cleo-faq__item');
    items.forEach(function (it) {
      it.addEventListener('toggle', function () {
        if (it.open && window.matchMedia('(max-width: 720px)').matches) {
          items.forEach(function (other) {
            if (other !== it) other.open = false;
          });
        }
      });
    });
  }

  /* ----------------------------------------------------------
     FORM — submit handler (REEMPLAZADO Cowork Sprint 4)
     El setupForm del ZIP apuntaba a IDs inexistentes. Reemplazado
     por el manejador probado de Sprint 1/3, apuntando a los IDs
     REALES del HTML. Las 3 calculadoras quedan 100% intactas.
     ---------------------------------------------------------- */
  function setupForm() {
    var form = document.getElementById('cleo-form-preregistro-empezar');
    var success = document.getElementById('cleo-form-success');
    var btn = document.getElementById('bl-pg-btn');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      // honeypot real: name="website"
      var hp = form.querySelector('input[name="website"]');
      if (hp && hp.value) return;
      // ciudad obligatoria (buscador custom)
      var cityVal = document.getElementById('bl-pg-city-val');
      var cityInput = document.getElementById('bl-pg-city-input');
      if (cityVal && !cityVal.value) {
        if (cityInput) { cityInput.style.borderColor = '#e0457a'; cityInput.focus(); }
        alert('Por favor elegí tu ciudad de la lista.');
        return;
      }
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Enviando…'; }
      var data = new FormData(form);
      fetch(form.action, { method: 'POST', body: data, mode: 'no-cors' })
        .then(function () { form.style.display = 'none'; if (success) success.classList.add('is-visible'); })
        .catch(function () { form.style.display = 'none'; if (success) success.classList.add('is-visible'); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = originalText; } });
    });

    // WhatsApp — formato suave
    var wa = document.getElementById('bl-pg-wa');
    if (wa) {
      wa.addEventListener('input', function () {
        var v = wa.value.replace(/[^\d]/g, '').slice(0, 10);
        if (v.length > 4) v = v.slice(0, 4) + ' ' + v.slice(4);
        if (v.length > 8) v = v.slice(0, 8) + ' ' + v.slice(8);
        wa.value = v;
      });
    }
  }

  /* ----------------------------------------------------------
     BUSCADOR DE CIUDAD CLEO (reemplaza datalist nativo) — Sprint 1
     ---------------------------------------------------------- */
  function setupCityDropdown() {
    var wrap = document.getElementById('cleo-city-wrap');
    var input = document.getElementById('bl-pg-city-input');
    var arrow = wrap ? wrap.querySelector('.cleo-city-arrow') : null;
    var dd = document.getElementById('cleo-city-dd');
    var search = document.getElementById('cleo-city-search');
    var list = document.getElementById('cleo-city-list');
    var hidden = document.getElementById('bl-pg-city-val');
    if (!wrap || !input || !dd || !list || !hidden) return;
    function openDD() {
      dd.classList.add('is-open'); wrap.classList.add('is-open');
      search.value = ''; filterList('');
      setTimeout(function () { search.focus(); }, 40);
    }
    function closeDD() { dd.classList.remove('is-open'); wrap.classList.remove('is-open'); }
    function filterList(q) {
      var qq = q.toLowerCase().trim(), anyVisible = false;
      list.querySelectorAll('li:not(.is-empty)').forEach(function (li) {
        var match = li.textContent.toLowerCase().indexOf(qq) >= 0;
        li.hidden = !match; if (match) anyVisible = true;
      });
      var empty = list.querySelector('.is-empty');
      if (!anyVisible) {
        if (!empty) {
          empty = document.createElement('li'); empty.className = 'is-empty';
          empty.textContent = 'Sin resultados — escribí tu ciudad';
          list.appendChild(empty);
        }
        empty.hidden = false;
      } else if (empty) { empty.hidden = true; }
    }
    input.addEventListener('click', function () { dd.classList.contains('is-open') ? closeDD() : openDD(); });
    if (arrow) arrow.addEventListener('click', function () { dd.classList.contains('is-open') ? closeDD() : openDD(); });
    search.addEventListener('input', function () { filterList(this.value); });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('li');
      if (!li || li.classList.contains('is-empty')) return;
      input.value = li.dataset.val; hidden.value = li.dataset.val;
      input.style.color = 'var(--cleo-negro)'; closeDD();
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) closeDD(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dd.classList.contains('is-open')) closeDD(); });
  }

  /* ----------------------------------------------------------
     SMOOTH SCROLL — anchors internos (#nivel-star/pro/mentora)
     ---------------------------------------------------------- */
  function setupSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var t = document.querySelector(id);
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  /* ----------------------------------------------------------
     INIT
     ---------------------------------------------------------- */
  function init() {
    splitHeroTitle();
    setupReveal();
    setupStar();
    setupPro();
    setupMentora();
    fillStarTable();
    fillProTable();
    fillMentoraTable();
    setupFaq();
    setupForm();
    setupCityDropdown();
    setupSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
